<template>
    <div>
        <TitleField style="font-size: 24px; color: #ffa409; text-align: center"> {{ $t('devis.devis_voyage.HeadLineSteper_6') }} </TitleField>
        <TitleField style="font-size: 24px;"> {{ $t('devis.devis_voyage.titreTableauRecapVoyage') }}&nbsp;: </TitleField>

        <div v-for="(value, name, index) in voyageInfo">
            <SubTitle class="col-lg-4"> {{ $t(`devis.devis_voyage.entetTableeauRec[${index}]`) }} </SubTitle>
            <FieldInput disabled class="col-lg-8" style="margin-bottom: 10px;" :value=" value.PAYS ? value.PAYS : value "></FieldInput>
        </div>
        <div v-for="(value, name, index) in filteredPassengerInfo" :key="name">
            <SubTitle class="col-lg-4"> {{ $t(`devis.devis_voyage.entetTableeauRec[${index+4}]`) }} </SubTitle>
            <FieldInput disabled style="margin-bottom: 10px;" class="col-lg-8" :value="value.value"></FieldInput>
        </div>
        <div class="fields">
            <TitleField style="font-size: 24px;"> {{ $t('devis.devis_voyage.entetChoixAssureurMobile') }}&nbsp;: </TitleField>
            <!-- Grid moderne pour les assureurs -->
            <div class="insurers-grid">
                <!-- Bouton "Tous" -->
                <div class="insurer-card all-insurers" :class="{ 'selected': selectAll }">
                    <input v-model="selectAll" type="checkbox" id="tous_voyage" class="insurer-input">
                    <label for="tous_voyage" class="insurer-label">
                        <div class="insurer-icon">
                            <img src="../../../assets/img/icones/all.png" alt="Tous les assureurs" class="insurer-logo">
                        </div>
                        <div class="insurer-info">
                            <h4 class="insurer-name">{{ $t('devis.devis_voyage.tous') }}</h4>
                            <span class="insurer-badge">Tous</span>
                        </div>
                        <div class="selection-indicator">
                            <i class="fas fa-check"></i>
                        </div>
                    </label>
                </div>

                <!-- Cartes des assureurs -->
                <div 
                    class="insurer-card" 
                    v-for="(assureur, index) in listAssureur" 
                    :key="index"
                    :class="{ 'selected': listAssureurValue.includes(assureur.societe) }"
                >
                    <input 
                        v-model="listAssureurValue" 
                        type="checkbox" 
                        :value="assureur.societe" 
                        :id="`assureur_${index}`"
                        class="insurer-input"
                    >
                    <label :for="`assureur_${index}`" class="insurer-label">
                        <div class="insurer-icon">
                            <img :src="assureur.logo" :alt="assureur.societe" class="insurer-logo">
                        </div>
                        <div class="insurer-info">
                            <h4 class="insurer-name">{{ assureur.societe }}</h4>
                            <span class="insurer-badge">Assureur</span>
                        </div>
                        <div class="selection-indicator">
                            <i class="fas fa-check"></i>
                        </div>
                    </label>
                </div>
            </div>

            <!-- Résumé de la sélection -->
            <div class="selection-summary" v-if="listAssureurValue.length > 0">
                <div class="summary-content">
                    <i class="fas fa-info-circle"></i>
                    <span>{{ listAssureurValue.length }} assureur{{ listAssureurValue.length > 1 ? 's' : '' }} sélectionné{{ listAssureurValue.length > 1 ? 's' : '' }}</span>
                </div>
            </div>
            <!-- <div class="field-group row field-bank">
                <div class="btn-choice col-sm-3">
                    <input v-model="selectAll" type="checkbox" id="tous" class="field-input">
                    <label for="tous" class="field-label" label="Tous">
                        <img src="../../../assets/img/icones/all.png" alt="Tous_mobile" height="60px" width="60px">
                        <p class="field-title" style="margin-top:-12px;margin-bottom:-10px;color:#ffa409">{{$t('devis.devis_voyage.tous')}}</p>
                    </label>
                </div>
                <div class="btn-choice col-sm-3" v-for="(assureur, index) in listAssureur" :key="index">
                    <input v-model="listAssureurValue" type="checkbox" :value="assureur.societe" :id="index" class="field-input">
                    <label :for="index" class="field-label" label="">
                        <img :src="assureur.logo" alt="Crédit Agricole" height="50px">
                        <p v-if="assureur.societe == 'FINAFRICA'" class="field-title" style="margin-top:-3px;margin-bottom:-10px">{{assureur.societe}}</p>
                        <p v-else class="field-title" style="margin-top:-3px;margin-bottom:-10px">{{assureur.societe.substring(0, 6)}}</p>
                    </label>
                </div>
            </div> -->
        </div>
        <div>
            <TitleField style="font-size: 24px;">
                {{ $t('devis.devis_voyage.periode') }}&nbsp;:
            </TitleField>
            <div class="row">
                <div class="col-sm-4">
                    <SubTitle style="display: block">
                        {{ $t('devis.devis_voyage.duree_garantie') }}
                    </SubTitle>
                    <div style="display: flex;">    
                        <FieldInput 
                            type="number"
                            disabled
                            style="flex: 6;"
                            v-model="calculateAgePassenger"
                        />
                        <div class="ml-2 prepend-birthday" style="flex: 2;">
                            {{ $t('devis.devis_voyage.jours') }}
                        </div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <SubTitle>
                        {{ $t('devis.devis_voyage.date_effet') }}
                    </SubTitle>
                     <FieldInput
                        style="display: block"
                        v-model="dateEffet"
                        disabled
                    ></FieldInput>
                    <!-- <DateInput
                        @valueDate="getDateEffet"
                        :default-date="dateEffet"
                        :date-range-to-disable="[dateEffet, dateEcheance]"
                    >
                    </DateInput> -->
                </div>
                <div class="col-sm-4">
                    <SubTitle>{{ $t('devis.devis_voyage.date_echeance') }}</SubTitle>
                    <FieldInput
                        style="display: block"
                        v-model="dateEcheance"
                        disabled
                    ></FieldInput>
                </div>
            </div> 
        </div>
        <div>
            <TitleField style="font-size: 24px;">
                {{ $t('devis.devis_voyage.modalite') }}&nbsp;:
            </TitleField>
            <div style="" class="row">
                <div class="btn-choice btn-choice-icon col-lg-6">
                    <input v-model="remboursable" value="remboursable" type="radio" id="remboursable_mobile" name="modalite_mobile" class="field-input">
                        <label for="remboursable_mobile" class="flex-row flex-md-column field-label">
                            <img src="../../../assets/img/icones/rembourse.png" class="mr-4 mr-md-0" alt="Remboursable">
                            <p>{{$t('devis.devis_voyage.remboursable')}}</p>
                        </label>
                </div>
                <div class="btn-choice btn-choice-icon col-lg-6">
                    <input v-model="remboursable" type="radio" value="Non_remboursable" id="non_remboursable_mobile" name="modalite_mobile" class="field-input">
                        <label for="non_remboursable_mobile" class="flex-row flex-md-column field-label">
                            <img src="../../../assets/img/icones/non-rembourse.png" class="mr-4 mr-md-0" alt="Non Remboursable">
                            <p>{{$t('devis.devis_voyage.non_remboursable')}}</p>
                        </label>
                </div>
            </div>
        </div> 
        <div class="bottom-button wizard-footer-left">
            <button 
                type="button" 
                class="wizard-btn"
                @click="decrementStepper()"
            >
                <span class="fas fa-arrow-left"></span>
                {{$t('devis.devis_voyage.bouton_retour')}}
            </button>

            <button 
                type="button" 
                class="filled-button"
                @click="saveDevisVoyage()"
            >
                {{$t('devis.devis_voyage.bouton_suivant')}}
            </button>
        </div>

        <div v-if="dialogLoading" class="loading-state">
        <div class="loading"></div>
        <span class="ml-3 loading-text">{{$t('devis.devis_voyage.devis_encours')}}</span>
    </div>

        <!-- <v-dialog v-model="dialogLoading" persistent width="700">
            <v-card elevation="24" class="border-radius">
                <v-card-text style="background:#FFA409">
                <div class="wizard-tab-content" style="background:#FFA409">
                    <div role="tabpanel" id="infosPerso" aria-hidden="true" aria-labelledby="step-infosPerso" class="wizard-tab-container">
                    <div>
                        <div class="loan-group loan-group-0" style="background:#FFA409">
                        <div class="fields text-center" style="background:#FFA409">
                            <v-progress-circular size="50" color="white" class="mr-2" indeterminate></v-progress-circular> 
                            <span class="field-title font-weight-bold" style="color:#fff">{{$t('devis.devis_voyage.devis_encours')}}</span>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </v-card-text>
            </v-card>
        </v-dialog> -->
        <!-- INCLUSION DU POPUP DE LOGIN AU CAS OU LE USER VOULANT FAIRE UNE VALIDATION N'EST PAS CONNECTE -->
    <login-form :visible="showLoginForm" @close="showLoginForm = false"></login-form>
    </div>
</template>

<script>
import DateInput from '../../layouts/FormInput/DateInput.vue';
import FieldInput from '../../layouts/FormInput/FieldInput.vue';
import SelectCard from '../../layouts/SelectCard.vue';
import SubTitle from '../../layouts/texts/SubTitle.vue';
import TitleField from '../../layouts/texts/TitleField.vue';
import {partner} from '../../../packages/assureurs/assureur.controller'
import ToastMixin from '../../../mixin/ToastMixin';
import dayjs from 'dayjs';
import configVoyage from "../../../common/configVoyage.json"
import { mapMutations } from 'vuex';
import Api from '../../../services/Api';
import LoginForm from '../../auth/Login'

    export default {
        name: "ValidationDevisVoyage",
        mixins: [ToastMixin],
        components: {
            LoginForm,
            TitleField,
            SubTitle,
            FieldInput,
            SelectCard,
            DateInput,
        },
        data() {
            return {
                voyageInfo: {},
                passengerInfo: {},
                listAssureur: [],
                dateEffet: "" ,
                dateEcheance: "",
                dateEffetValue: "",
                listAssureurValue: [],
                remboursable: null,
                branche: "Voyage",
                disabledButtonValidate: false,
                dialogLoading: false,
                objectPaysDestination: {},
                showLoginForm: false,
            }
        },
        created() {
            this.voyageInfo = this.$store.state.devisVoyageContainer.travel || {}
            this.passengerInfo = this.$store.state.devisVoyageContainer.passenger || {}
            this.dateEffet = this.voyageInfo.departureDate
            this.dateEcheance = this.voyageInfo.arrivalDate
            this.dateEffetValue = this.voyageInfo.departureDate
        },
        computed: {
            selectAll: {
                set(value) {
                    if (value) {
                        this.listAssureur.forEach((data) => {
                            this.listAssureurValue.push(data.societe)
                        })
                    }else {
                        this.listAssureurValue = []
                    }
                }
            },
            calculateAgePassenger() {
                return dayjs(this.dateEcheance).diff(this.dateEffetValue, "day")
            },
            filteredPassengerInfo() {
                const excluded = ['passport', 'passportOcrDone']
                return Object.keys(this.passengerInfo).reduce((acc, key) => {
                    if (!excluded.includes(key)) acc[key] = this.passengerInfo[key]
                    return acc
                }, {})
            },
        },
        methods: {
            ...mapMutations([
                "decrementStepper",
            ]),
            getDateEffet(date) {
                this.dateEffetValue = date
            },
            async getListPartenaire () {
                try {
                    this.listAssureur = await partner.getListAssureur()
                } catch (error) {
                    return this.$toasted.show(error.message, this.ToastTabError) 
                }
            },
            async saveDevisVoyage () {
                if (!this.$store.state.isUserLoggedIn) {
                    this.showLoginForm = true
                    console.log('showLoginForm : ', this.showLoginForm) 
                } else {
                    if (this.listAssureurValue.length === 0) return this.$toasted.show("Selectionner au moins un assureur", this.ToastTabError);
                            if (this.remboursable === null ) return this.$toasted.show("Modalités de remboursement obligatoire !", this.ToastTabError);
                            if (this.dateEffetValue === "") return this.$toasted.show("Date d'effet obligatoire ! ", this.ToastTabError);
                            
                            const list_pass = [{
                                age_passager: dayjs(new Date()).diff(this.passengerInfo.birthday.date, "year"),
                                dateNaissance: this.passengerInfo.birthday.date,
                                adulte_enfant: "EnfantAdulte"
                            }]

                            const Voyage = {
                                user: this.$store.state.user._id,
                                createur: this.$store.state.user._id,
                                destination: this.voyageInfo.destinationCountry,
                                nbpassager: this.passengerInfo.number.value,
                                dateEffet: typeof this.dateEffetValue === String ? this.dateEffetValue: dayjs(this.dateEffetValue).format("YYYY-MM-DD"),
                                dateNaissance: this.passengerInfo.birthday.date,
                                clientid: this.$store.state.user._id,
                                dateEcheance: dayjs(this.voyageInfo.arrivalDate).add(1, 'day').format('YYYY-MM-DD'),
                                duree: this.calculateAgePassenger,
                                dateSouscription: dayjs(new Date()).format('YYYY-MM-DD'),
                                mode_remboursement: this.remboursable,
                                dateDepart: this.voyageInfo.departureDate,
                                dateArrivee: this.voyageInfo.arrivalDate,
                                assureurs: this.listAssureurValue,
                                branche: this.branche,
                                listPassager: list_pass,
                                garanties: configVoyage.French.Garanties,
                                plateforme:"Front",
                                autres_garanties: this.autres_garanties,
                                pays_domicile: this.voyageInfo.originCountry,
                                // Passport OCR data
                                passportOcrDone: this.passengerInfo.passportOcrDone || false,
                                passport: this.passengerInfo.passport || null
                            };

                            console.log("recap : ", Voyage)

                            this.disabledButtonValidate = true
                            this.dialogLoading = true;
                        
                            Api().post('devis/add', Voyage)
                                .then(result => {
                                    // let GtmVal = {
                                    //     branche : 'voyage',
                                    //     entry_point: localStorage.getItem('quoteCreationEntryPoint'),
                                    //     insurer_number: this.assureurs.length,
                                    //     event:'quote_creation'
                                    // }
                                    // PushInDataLayer(GtmVal)

                                    if (result.data.message) {
                                        this.$store.dispatch('setDevis', result.data);
                                            this.dialogLoading = false, 
                                            this.disabledButtonValidate = false, 
                                            this.$router.push({name: 'listDevis'})
                                    }

                                    this.$store.dispatch("resetStepperAction");
                                }).catch(error=>{
                                    this.$toasted.show(error.response.data.message, this.ToastTabError)
                                    this.dialogLoading = false
                                    this.disabledButtonValidate = false
                                })
                }
               
            }
        },
        mounted() {
            window.scrollTo(0, 0);
            this.getListPartenaire()
        }
    }
</script>

<style scoped>
.prepend-birthday {
        background-color: #fff;
        border-radius: 15px;
        border: 1px solid #d9dee3;
        text-align: center;
        padding: 15px 0;
    }

    .bottom-button {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 150px;
    }

    .filled-button {
        right: 0;
        padding: 12px 40px;
        border-radius: 50px;
        color: #fff;
        border: 1px solid #ffa409;
        background-color: #ffa409;
        font-size: 1.8rem;
        text-transform: uppercase;
        font-weight: 400;
    }


.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}





/* Styles pour les cartes d'assureurs - repris du composant auto.desktop.vue */
.insurers-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
}

@media (max-width: 768px) {
  .insurers-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
}

.insurer-card {
  position: relative;
  border-radius: 12px;
  background: #ffffff;
  border: 2px solid #e2e8f0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.insurer-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border-color: #cbd5e0;
}

.insurer-card.selected {
  border-color: #ffa409;
  background: linear-gradient(135deg, #fff7ed 0%, #ffffff 100%);
}

.insurer-card.all-insurers {
  background: linear-gradient(135deg, #ffa409 0%, #ff8c00 100%);
  border-color: #ffa409;
  color: white;
}

.insurer-card.all-insurers.selected {
  background: linear-gradient(135deg, #e69500 0%, #cc7a00 100%);
  transform: scale(1.02);
}

.insurer-input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.insurer-label {
  display: flex;
  align-items: center;
  padding: 1.25rem;
  cursor: pointer;
  width: 100%;
  height: 100%;
  position: relative;
  transition: all 0.3s ease;
}

.insurer-icon {
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7fafc;
  border-radius: 12px;
  margin-right: 1rem;
  transition: all 0.3s ease;
}

.insurer-card.selected .insurer-icon {
  background: rgba(255, 164, 9, 0.1);
}

.insurer-card.all-insurers .insurer-icon {
  background: rgba(255, 255, 255, 0.2);
}

.insurer-logo {
  max-width: 45px;
  max-height: 45px;
  object-fit: contain;
  filter: brightness(1);
  transition: all 0.3s ease;
}

.insurer-card.all-insurers .insurer-logo {
  filter: brightness(0) invert(1);
}

.insurer-info {
  flex: 1;
  min-width: 0;
}

.insurer-name {
  font-weight: 500;
  color: #2d3748;
  margin: 0 0 0.25rem 0;
  line-height: 1.2;
  word-break: break-word;
}

.insurer-card.all-insurers .insurer-name {
  color: white;
}

.insurer-badge {
  display: inline-block;
  font-size: 0.90rem;
  font-weight: 500;
  color: #718096;
  background: #edf2f7;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.insurer-card.all-insurers .insurer-badge {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.insurer-card.selected .insurer-badge {
  background: rgba(255, 164, 9, 0.2);
  color: #b45309;
}

.selection-indicator {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  opacity: 0;
  transform: scale(0.8);
}

.insurer-card.selected .selection-indicator {
  opacity: 1;
  transform: scale(1);
  background: #ffa409;
  color: white;
}

.selection-indicator i {
  font-size: 0.75rem;
}

.selection-summary {
  background: linear-gradient(135deg, #e6fffa 0%, #f0fff4 100%);
  border: 1px solid #9ae6b4;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1rem;
}

.summary-content {
  display: flex;
  align-items: center;
  color: #2f855a;
  font-weight: 500;
}

.summary-content i {
  margin-right: 0.5rem;
  font-size: 1.1rem;
}

/* Animation d'entrée */
.insurer-card {
  animation: slideInUp 0.6s ease-out;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Animation pour les cartes sélectionnées */
.insurer-card.selected {
  animation: pulse 0.6s ease-out;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.02);
  }
  100% {
    transform: scale(1);
  }
}

/* Responsive amélioré */
@media (max-width: 480px) {
  .insurer-label {
    padding: 1rem;
  }
  
  .insurer-icon {
    width: 50px;
    height: 50px;
    margin-right: 0.75rem;
  }
  
  .insurer-logo {
    max-width: 35px;
    max-height: 35px;
  }
  
  .insurer-name {
    font-size: 1.5rem;
  }
}

/* Amélioration de l'accessibilité */
.insurer-card:focus-within {
  outline-offset: 2px;
}

.insurer-input:focus + .insurer-label {
  box-shadow: 0 0 0 3px rgba(255, 164, 9, 0.3);
}

/* États de chargement */
.insurers-grid.loading .insurer-card {
  opacity: 0.6;
  pointer-events: none;
}
</style>